<template>
  <div :class="appClass">
    <div class="app-body">
      <TopHeader ref="topHeader" @session-invalidated="onSessionInvalidated" />
      <DashboardPage v-if="isLoggedIn" @image-returned="refreshHeaderTokens" />
      <LandingPage v-else :is-logged-out="!isLoggedIn" />
    </div>
    <AppFooter :variant="isDashboard ? 'dashboard' : 'landing'" />
  </div>
</template>

<script>
import LandingPage from './components/LandingPage.vue'
import DashboardPage from './components/Dashboard.vue'
import TopHeader from './components/TopHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
	name: 'App',
  data() {
    return {
      isLoggedIn: window.utils.cookies.has('token'),
    }
  },
  provide() {
    const self = this
    return {
      openSignupModal() {
        self.$refs.topHeader?.openSignupModal?.()
      },
    }
  },
  methods: {
    refreshHeaderTokens() {
      this.$refs.topHeader?.getTokens?.()
    },
    onSessionInvalidated() {
      this.isLoggedIn = false
    },
  },
	components: {
    TopHeader,
    LandingPage,
    DashboardPage,
    AppFooter,
	},
  computed: {
    isDashboard() {
      const searchParams = new URLSearchParams(window.location.search || '');
      const page = (searchParams.get('page') || '').toLowerCase();

      return page === 'dashboard';
    },
    appClass() {
      return this.isDashboard ? 'app app--dashboard' : 'app app--landing';
    }
  }
}
</script>

<style>
.app {
  font-family: "Inter", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-body {
  flex: 1 0 auto;
}

.app--landing {
  color: #f7f7fb;
  background: #04050c;
}

.app--dashboard {
  color: #2c3e50;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
}

button:not(:disabled):hover {
  opacity: 0.5;
}

a[href] {
  cursor: pointer;
}

input[type="button"]:not(:disabled),
input[type="submit"]:not(:disabled),
input[type="reset"]:not(:disabled) {
  cursor: pointer;
}

input[type="button"]:disabled,
input[type="submit"]:disabled,
input[type="reset"]:disabled {
  cursor: not-allowed;
}
</style>
